import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';
import { PlayerAvatar } from '@sorare/core/src/components/seo/PlayerAvatar';
import { Row } from '@sorare/core/src/components/seo/ui';

const StyledBodyS = styled(BodyS)`
  display: flex;
  gap: var(--half-unit);
`;

type Props<T extends string> = {
  stats: T[];
  player: {
    slug: string;
    pictureUrl?: string | null;
    displayName: string;
    position?: string;
    stats: Record<T, ReactNode>;
    to?: string;
  };
};

export const TopPlayer = <T extends string>({ player, stats }: Props<T>) => {
  return (
    <Row
      style={{
        gridTemplateColumns: `auto 1fr repeat(${stats.length}, calc(${
          16 / stats.length
        } * var(--unit)))`,
      }}
    >
      <PlayerAvatar src={player.pictureUrl} alt={player.displayName} />
      <Vertical gap={0}>
        <BodyM as="p">
          {player.to ? (
            <Link to={player.to}>{player.displayName}</Link>
          ) : (
            player.displayName
          )}
        </BodyM>
        {!!player.position && (
          <StyledBodyS as="p" color="var(--c-nd-600)">
            {player.position}
          </StyledBodyS>
        )}
      </Vertical>
      {stats.map(stat => (
        <BodyM as="p" key={stat}>
          {player.stats[stat]}
        </BodyM>
      ))}
    </Row>
  );
};
